export default __webpack_public_path__ + "static/media/play.4b4d777c.svg";